import { Pipe, PipeTransform } from '@angular/core';

const STATUS_LABELS: Record<string, string> = {
  incomplete: 'Incomplete',
  complete: 'Complete',
  po_under_review: 'PO Under Review',
  po_approved: 'PO Approved',
  in_production: 'In Production',
  shipping: 'Shipping',
  delivered: 'Delivered',
  installation: 'Installation',
  completed: 'Completed',
  complete_datasheet: 'Complete Datasheet',
  pending: 'Sent for Approval',
  approved: 'Approved'
};

@Pipe({
    name: 'statusLabel',
    standalone: false
})
export class StatusLabelPipe implements PipeTransform {

  transform(status: string | null | undefined): string {
    if (status == null || status === '') {
      return '';
    }

    return STATUS_LABELS[status] || this.toTitle(status);
  }

  private toTitle(value: string): string {
    return value
      .replaceAll('_', ' ')
      .replace(/\b\w/g, (part) => part.toUpperCase());
  }

}
